import React from "react";
import { useNavigate } from "react-router-dom";
import Card from "../components/Card/Card";
import { useProjetosBanco } from "../hooks/useProjetosComBanco";
import { projetoEhDoTipo } from "../utils/projetos";

function RV() {
  const navigate = useNavigate();
  const todosProjetos = useProjetosBanco();
  const projetosRV = todosProjetos.filter((p) => projetoEhDoTipo(p, "RV"));

  const handleCardClick = (id) => {
    navigate(`/projeto/${id}`);
  };

  return (
    <div className="pagina-categoria">
      <h1>Projetos de Realidade Virtual</h1>
      <div className="cards-container">
        {projetosRV.map((projeto) => (
          <Card key={projeto.id} projeto={projeto} onClick={handleCardClick} />
        ))}
      </div>
    </div>
  );
}

export default RV;

